import { FC, Fragment, useState, useCallback } from 'react'
import { Row, Col, Icon, Text, Content, Collapse, CollapseItem } from '@/client/components'
import * as S from './styles'
import { ListProps } from '../types'

export const List: FC<ListProps> = ({ search_input_label, list }) => {
  const [searchValue, setSearchValue] = useState<string>('')

  const handleChangeSearchValue = useCallback(({ currentTarget: { value } }) => {
    setSearchValue(value)
  }, [])

  return (
    <Row>
      <Col xs={12}>
        <S.Search
          isBlock
          id='input-search'
          type='search'
          placeholder={search_input_label}
          value={searchValue}
          onChange={handleChangeSearchValue}
          autoComplete='off'
          rightElement={
            <S.SearchIcon aria-label='Ir página de busca'>
              <Icon name='search' size='s5' />
            </S.SearchIcon>
          }
        />

        {list &&
          list?.length > 0 &&
          list
            .filter(
              ({ title, collapse }) =>
                title.toLowerCase().includes(searchValue) ||
                collapse.some(
                  ({ title, content }) =>
                    title.toLowerCase().includes(searchValue) || content.toLowerCase().includes(searchValue)
                )
            )
            .map(({ title, collapse }) => (
              <Fragment key={title}>
                <Text family='heading' size='lg' color='primary' weight='bold' margin='3rem 0 1rem'>
                  {title}
                </Text>

                {collapse.length > 0 &&
                  collapse
                    .filter(
                      (item) =>
                        item.title.toLowerCase().includes(searchValue) ||
                        item.content.toLowerCase().includes(searchValue)
                    )
                    .map((item) => (
                      <Collapse key={item.title} kind='modern'>
                        <CollapseItem title={item.title}>
                          <Content content={item.content} />
                        </CollapseItem>
                      </Collapse>
                    ))}
              </Fragment>
            ))}
      </Col>
    </Row>
  )
}
